import { Observable } from 'rxjs';
import { InjectionToken } from '@angular/core';

import { UserContext } from './user-context.types';

export const WO_CONTEXT_HEADER = 'X-WO-Context';
export const WO_USER_CONTEXT = new InjectionToken<Observable<UserContext | null>>('WO_USER_CONTEXT');
